const GMAPS_CALLBACK_NAME = 'gmapsCallback';

let promise = null;

export const gmapApiLoader = (googleApiKey) => {
    promise = promise || new Promise((resolve, reject) => {

        let timeout = setTimeout(function () {
            window[GMAPS_CALLBACK_NAME] = function () {};
            reject(new Error('Google maps could not be loaded. Please contact administrator.'));
        }, 10000);

        window[GMAPS_CALLBACK_NAME] = function () {
            if (timeout !== null) {
                clearTimeout(timeout);
            }
            resolve(window.google.maps);
            delete window[GMAPS_CALLBACK_NAME];
        };

        const script = document.createElement('script');
        script.async = true;
        script.defer = true;
        script.src = `https://maps.googleapis.com/maps/api/js?libraries=drawing,places&language=en-US&key=${googleApiKey}&callback=${GMAPS_CALLBACK_NAME}`;
        script.onerror = reject;

        document.body.appendChild(script);
    });

    return promise;
};
